// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__8BvwN","insightsList":"newBusinessInsightsMenu_insightsList__hh2O4","active":"newBusinessInsightsMenu_active__1Oq92"};